import React, { useEffect, useRef } from "react";

import locale from "../../_util/locale";

import { IItemData } from "./common.typing";

import PageTitle from "./PageTitle";
import OrgBread from "./OrgBread";
import OrgList from "./OrgList";

import { idTrans } from "./utils";
//import "./index.less";

export interface IOrganizationProps {
    type?: string;
    prePage: string;
    onChangeCurPage: (page: string) => void;
    currentList: IItemData[];
    setCurrentList: (list: IItemData[]) => void;
    getOrgList?: (obj?: IItemData, from?: string) => void;
    orgBread?: IItemData[];
    orgList?: IItemData[];
    orgUser?: IItemData[];
    /** 不可用 id，包括 group、user、session、org */
    disabledids?: string[];
    requiredList?: IItemData[];
    personOrg?: IItemData;
    multiple?: boolean;
    orginSelect?: boolean;
}

const Organization: React.FC<IOrganizationProps> = ({
    type,
    prePage,
    onChangeCurPage,
    currentList,
    setCurrentList,
    getOrgList,
    orgBread = [],
    orgList,
    orgUser,
    disabledids = [],
    requiredList,
    personOrg,
    multiple,
    orginSelect,
}) => {
    // orginSelect为true时保证personOrg数据拿到后，自动获取根list
    useEffect(() => {
        if (orginSelect && personOrg) {
            getOrgList && getOrgList(personOrg, "top-level");
        }
    }, [personOrg]);
    /**
     * pageTitle 返回
     * prePage: home
     */
    const onBack = () => {
        onChangeCurPage(prePage);
    };

    /**
     * 根据部门 id 返回组织架构信息
     * @param id 部门 id
     */
    const onClickNextDep = (org: IItemData) => {
        if (isSubDisabled(org)) return;
        getOrgList && getOrgList(org);
    };

    /**
     * 判断当前部门是否可点击【下级】
     * @param org 部门信息
     */
    const isSubDisabled = org => {
        const curDisabled = !!currentList.filter(item => item.id === org.id)
            .length;
        const id = idTrans(org.id.toString());
        const isDisabled = disabledids.includes(id);
        const noSub = type === "org" && !org.hasSubOg;

        return curDisabled || isDisabled || noSub;
    };

    /**
     * 选择部门信息组件的头部标题
     * @param pageTitle 头部标题
     */
    let pageTitle = "";
    orgBread &&
        orgBread.map((item, index) => {
            if (index === 0) pageTitle = item.name;
        });

    return (
        <div className="organization">
            <PageTitle
                {...{
                    // title: locale("common_tal"),
                    // title:
                    //     personOrg && personOrg.corpName
                    //         ? personOrg.corpName
                    //         : pageTitle,

                    title: locale("useradd_type_org"),
                    customStyle: { borderBottom: "none" },
                    onBack,
                }}
            />
            {orgBread && !!orgBread.length && orgBread.length > 1 && (
                <OrgBread
                    {...{
                        orgBread,
                        getOrgList,
                    }}
                />
            )}
            <OrgList
                {...{
                    type,
                    currentList,
                    setCurrentList,
                    orgList,
                    orgUser,
                    onClickNextDep,
                    isSubDisabled,
                    disabledids,
                    requiredList,
                    multiple,
                }}
            />
        </div>
    );
};
export default Organization;
